import { render, staticRenderFns } from "./yaslandirmaicmali.vue?vue&type=template&id=f2b39e6c&"
import script from "./yaslandirmaicmali.vue?vue&type=script&lang=js&"
export * from "./yaslandirmaicmali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports